// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetMyBookingOfferResponse

export type WidgetMyBookingOfferApiResponse = {
	id: string;
	name: string;
	shortDescription: string | null;
	presentation: string | null;
	qrCodeEnabled: boolean;
	image: string | null;
	postBookingInfo: string | null;
	minPax: number;
	maxPax: number;
};

export type WidgetMyBookingOffer = {
	id: string;
	name: string;
	shortDescription: string | null;
	presentation: string | null;
	qrCodeEnabled: boolean;
	image: string | null;
	postBookingInfo: string | null;
	minPax: number;
	maxPax: number;
};

export function hydrateWidgetMyBookingOffer(data: WidgetMyBookingOfferApiResponse): WidgetMyBookingOffer {
	return { ...data };
}